/**
 * Event fired when types something into the message text field
 */
var messageTextChanged = function messageTextChanged() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$messageText = _ref.messageText,
      messageText = _ref$messageText === void 0 ? '' : _ref$messageText;

  return {
    type: 'messenger-message-text-changed',
    payload: {
      messageText: messageText
    }
  };
};
/**
 * Event fired when user clicks the redesign request checkbox
 */


var redesignRequestChanged = function redesignRequestChanged() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$isRedesign = _ref2.isRedesign,
      isRedesign = _ref2$isRedesign === void 0 ? false : _ref2$isRedesign;

  return {
    type: 'messenger-is-redesign-changed',
    payload: {
      isRedesign: isRedesign
    }
  };
};
/**
 * Event fired when a user clicks send
 */


var sendMessage = function sendMessage() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$isRedesign = _ref3.isRedesign,
      isRedesign = _ref3$isRedesign === void 0 ? false : _ref3$isRedesign,
      messageText = _ref3.messageText;

  return {
    type: 'messenger-send-message',
    payload: {
      isRedesign: isRedesign,
      messageText: messageText
    }
  };
};
/**
 * Event fired when load next page is called
 */


var loadMoreMessages = function loadMoreMessages() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      page = _ref4.page,
      spaceId = _ref4.spaceId;

  return {
    type: 'messenger-load-more-messages',
    payload: {
      page: page,
      spaceId: spaceId
    }
  };
};

export { loadMoreMessages, messageTextChanged, redesignRequestChanged, sendMessage };